
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";

interface CommentUserHoverCardProps {
  avatar: string;
  name: string;
  isJournalist?: boolean;
  bio?: string;
  joinDate?: string;
  children: React.ReactNode;
}

const CommentUserHoverCard: React.FC<CommentUserHoverCardProps> = ({
  avatar,
  name,
  isJournalist,
  bio,
  joinDate,
  children
}) => {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div>{children}</div>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <div className="flex justify-between space-x-4">
          <Avatar className="h-12 w-12">
            <AvatarImage src={avatar} alt={name} />
            <AvatarFallback>{name.substring(0, 2)}</AvatarFallback>
          </Avatar>
          <div className="space-y-1 flex-1">
            <h4 className="text-sm font-semibold flex items-center gap-2">
              {name}
              {isJournalist && (
                <Badge variant="outline" className="ml-1 bg-primary/10 text-primary text-xs">
                  Journalist
                </Badge>
              )}
            </h4>
            <p className="text-sm text-muted-foreground">
              {bio}
            </p>
            <div className="flex items-center pt-2">
              <span className="text-xs text-muted-foreground">
                {joinDate}
              </span>
            </div>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

export default CommentUserHoverCard;
